import { render } from "./CategoryHome.vue?vue&type=template&id=16a214b8"
import script from "./CategoryHome.vue?vue&type=script&lang=js"
export * from "./CategoryHome.vue?vue&type=script&lang=js"

import "./CategoryHome.vue?vue&type=style&index=0&id=16a214b8&lang=css"
script.render = render

export default script